import { toggle_loader, disable_loader } from '../../../src/js/loader.js';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Toastify from 'toastify-js'; //we'll fetch the endpoint to query based on the display method

var endpoint = false; //defines our variables for the map and list elements

var installersMap = false;
var installersList = false;
var installersForm = false; //array to hold the map pins

var markers = []; //bool to determine if the display installers function has been called

var installers_rendering = false; //variable to hold the last time we checked for existing quotes

var lastCheckTime = 0;
document.addEventListener("DOMContentLoaded", function () {
  //fetch the installer map element
  installersMap = document.getElementById("installersMap"); //fetch the installer list element

  installersList = document.getElementById("installersList"); //fetch the installer list element

  installersForm = document.getElementsByClassName("installer-form-block"); //if the installer map, list or block element exists

  if (installersMap || installersList || installersForm) {
    //initialize our quote handler
    init_quote_handler(); //if we're displaying using the map

    if (installersMap) {
      //fetch the endpoint from the map
      endpoint = installersMap.dataset.endpoint; //initialize the map

      init_map();
    } else if (installersList) {
      //fetch the endpoint from the map
      endpoint = installersList.dataset.endpoint;
    } //if we have a map or list


    if (installersMap || installersList) {
      //get the installers
      get_installers();
    }
  }
});

function get_installers() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  //toggle our loader
  toggle_loader(); //attempt to find our quote ID

  var quote_id = document.getElementById('quote_id').value; //create a default request slug

  var request_slug = endpoint + (quote_id ? '?quote=' + quote_id : ''); //if we have a form

  if (form) {
    var _form$querySelector$v, _form$querySelector$v2, _form$querySelector$c, _form$querySelector$c2, _form$querySelector$c3;

    //fetch the location and proximity from the form
    var location = (_form$querySelector$v = form.querySelector('#installer-search-location').value) !== null && _form$querySelector$v !== void 0 ? _form$querySelector$v : 'DN41 8FF';
    var proximity = (_form$querySelector$v2 = form.querySelector('#installer-search-proximity').value) !== null && _form$querySelector$v2 !== void 0 ? _form$querySelector$v2 : 100; //fetch the zappi, eddi and libbi checkboxes from the form

    var zappi = form.querySelector('#installer-search-zappi') ? (_form$querySelector$c = form.querySelector('#installer-search-zappi').checked) !== null && _form$querySelector$c !== void 0 ? _form$querySelector$c : false : false;
    var eddi = form.querySelector('#installer-search-eddi') ? (_form$querySelector$c2 = form.querySelector('#installer-search-eddi').checked) !== null && _form$querySelector$c2 !== void 0 ? _form$querySelector$c2 : false : false;
    var libbi = form.querySelector('#installer-search-libbi') ? (_form$querySelector$c3 = form.querySelector('#installer-search-libbi').checked) !== null && _form$querySelector$c3 !== void 0 ? _form$querySelector$c3 : false : false; // build up a longer request slug

    request_slug = endpoint + '?' + (location ? 'location=' + location + '&' : '') + (proximity ? 'proximity=' + proximity + '&' : '') + (zappi ? 'zappi=true&' : '') + (eddi ? 'eddi=true&' : '') + (libbi ? 'libbi=true&' : '');
  } //default to not fetching cached results


  var cached_installers = false; //if the site we're on is not local

  if (window.location.hostname !== 'myenergi.local') {
    //attempt to fetch the cached installers from session storage
    cached_installers = sessionStorage.getItem(request_slug);
  } //if we have a cached response


  if (cached_installers) {
    var _installersMap;

    //parse the cached response
    var installers = JSON.parse(cached_installers); //display the installers

    display_installers(installers.data, installers.origin, installers.default, (_installersMap = installersMap) !== null && _installersMap !== void 0 ? _installersMap : installersList);
  } else {
    //otherwise we need to make a new request
    //create a new request
    var xhttp = new XMLHttpRequest(); //when the request state changes

    xhttp.onreadystatechange = function () {
      //if our request is complete
      if (this.status === 200) {
        //default to no installers
        var _installers = false; //try...

        try {
          var _installersMap2;

          //... to parse the response
          _installers = JSON.parse(xhttp.responseText); //display the installers

          display_installers(_installers.data, _installers.origin, _installers.default, (_installersMap2 = installersMap) !== null && _installersMap2 !== void 0 ? _installersMap2 : installersList); //cache this response in session using the request_slug as the key

          sessionStorage.setItem(request_slug, JSON.stringify(_installers)); //prevent this from running again

          xhttp.onreadystatechange = null;
        } catch (error) {//if there's an error...
          //ignore it, we don't need to do anything
        }
      }
    }; //open the request


    xhttp.open("GET", request_slug, true); //if we have a map

    if (installersMap) {
      //clear all the markers
      for (var i = 0; i < markers.length; i++) {
        //set the map to null
        markers[i].setMap(null);
      } //empty the markers array


      markers = [];
    } else if (installersList) {
      //otherwise if we have a list
      //empty the list
      installersList.innerHTML = ''; //adds 8 skeleton loaders

      for (var _i = 0; _i < 8; _i++) {
        //add a skeleton loader
        installersList.innerHTML += "<nb-skeleton class=\"block h-24 w-full rounded-3xl overflow-hidden mb-2\"></nb-skeleton>";
      }
    } //send the request


    xhttp.send();
  }
}

function init_map() {
  var _installersMap$getAtt;

  //create a variable to hold the map
  window.installer_map = false; //get the latitude and longitude from the data attributes

  var lat = parseFloat(installersMap.getAttribute("data-lat"));
  var lng = parseFloat(installersMap.getAttribute("data-lng")); //fetch our pin grouping from the data attribute

  window.installer_map_pin_grouping = (_installersMap$getAtt = installersMap.getAttribute("data-pin_grouping")) !== null && _installersMap$getAtt !== void 0 ? _installersMap$getAtt : 'false'; //cast the pin grouping to a boolean

  window.installer_map_pin_grouping = window.installer_map_pin_grouping === 'true' || window.installer_map_pin_grouping === true; //initialize the map

  window.installer_map = new google.maps.Map(document.getElementById("installersMap"), {
    center: {
      lat: lat,
      lng: lng
    },
    zoom: 3,
    mapTypeControl: false,
    streetViewControl: false,
    minZoom: 9,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_RIGHT
    },
    zoomControl: true,
    fullscreenControl: false,
    styles: [{
      featureType: "all",
      elementType: "labels",
      stylers: [{
        visibility: "off"
      }]
    }, {
      featureType: "road",
      elementType: "labels",
      stylers: [{
        visibility: "off"
      }]
    }]
  });
}

function display_installers(installers, origin, default_search, container) {
  //if we're already rendering, bail
  if (installers_rendering) return; //set this to true

  installers_rendering = true; //determine which view we're rendering

  var view = container.getAttribute('id') == 'installersMap' ? 'map' : 'list'; //if we have some installers to display

  if (installers) {
    //if we're rendering as a map
    if (view === 'map') {
      //we'll store our positions here to quickly check for overlaps
      var marker_positions = [];
      /**
       Add pins for the installers
      */

      var _loop = function _loop(i) {
        //fetch our data
        var data = installers[i]; //create our standard icon

        var icon = {
          url: installers_script_vars.theme_path + '/graphics/installers/pin.svg',
          origin: new google.maps.Point(0, 0),
          // origin
          scaledSize: new google.maps.Size(28, 43)
        }; //create our active icon

        var activeIcon = {
          url: installers_script_vars.theme_path + '/graphics/installers/pin-active.svg',
          scaledSize: new google.maps.Size(28, 43)
        }; //create our quoted icon

        var quotedIcon = {
          url: installers_script_vars.theme_path + '/graphics/installers/pin-quoted.svg',
          scaledSize: new google.maps.Size(28, 43)
        }; //keep track of the original icon

        var originalIcon = icon; //check to see if we have a pin in this position already, if we do we need to change the position to be close by but not overlapping

        if (marker_positions.includes(data['lat'] + ',' + data['lng'])) {
          //small offset to avoid overlap
          var offset = 0.0001; //ensure lat/lng remain valid numbers and within typical bounds

          var newLat = parseFloat((parseFloat(data['lat']) + offset * (Math.random() > 0.5 ? 1 : -1)).toFixed(6));
          var newLng = parseFloat((parseFloat(data['lng']) + offset * (Math.random() > 0.5 ? 1 : -1)).toFixed(6)); //clamp latitude to -90..90 and longitude to -180..180

          newLat = Math.max(-90, Math.min(90, newLat));
          newLng = Math.max(-180, Math.min(180, newLng)); //update the data with the new position

          data['lat'] = newLat;
          data['lng'] = newLng;
        } //add the position to our marker positions


        marker_positions.push(data['lat'] + ',' + data['lng']); //add the marker to the map

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(data['lat'], data['lng']),
          //get the first and second items (latitude and longitude)
          map: window.installer_map,
          optimized: false,
          icon: icon
        }); //set the default icon

        marker['originalIcon'] = originalIcon; //add identifier to the marker

        marker['installerId'] = data['data']['id']; //push the marker to our markers array

        markers.push(marker); //create the info window for this marker

        var infoWindow = new google.maps.InfoWindow({
          content: '<div class="installer-info">' + render_item(data, view, default_search) + '</div>'
        }); //add the info window to the marker

        marker.infoWindow = infoWindow; //register a click event listener for the marker

        google.maps.event.addListener(marker, 'click', function (marker, i) {
          return function () {
            //check if the info window is already open
            if (infoWindow.getMap()) {
              //close the info window
              infoWindow.close(); //if the marker is not already quoted

              if (marker.getIcon().url !== quotedIcon.url) {
                //set the icon back to the original icon
                marker.setIcon(marker['originalIcon']);
              }
            } else {
              //close all info windows first
              for (var j = 0; j < markers.length; j++) {
                //if the info window is open
                if (markers[j].infoWindow) {
                  //close it
                  markers[j].infoWindow.close(); //if the marker is not already quoted

                  if (markers[j].getIcon().url !== quotedIcon.url) {
                    //set the icon back to the original icon
                    markers[j].setIcon(markers[j]['originalIcon']);
                  }
                }
              } //open the info window


              infoWindow.open(window.installer_map, marker); //if the marker is not already quoted

              if (marker.getIcon().url !== quotedIcon.url) {
                //set the active icon
                marker.setIcon(activeIcon);
              } //allow time for the info window to render


              setTimeout(function () {
                //quickly check for existing cached quotes
                check_existing_quotes(true);
              }, 10);
            }
          };
        }(marker, i));
      };

      for (var i = 0; i < installers.length; i++) {
        _loop(i);
      } //update our global markers variable


      window.installer_markers = markers; //if we have an origin

      if (origin) {
        //re-center the map
        window.installer_map.setCenter(new google.maps.LatLng(origin['lat'], origin['lng'])); //re-zoom the map

        window.installer_map.setZoom(10);
      } //check if we have any existing quotes


      check_existing_quotes(); //require our debounce function

      var debounce = require('debounce'); //add event listeners to the map to hide unecessary markers when not in view


      google.maps.event.addListener(window.installer_map, "dragend", debounce(hide_markers), 150);
      google.maps.event.addListener(window.installer_map, "zoom_changed", debounce(hide_markers), 150); //trigger the hide markers function now

      hide_markers(); //if pin grouping is enabled

      if (window.installer_map_pin_grouping) {
        //group the markers
        group_markers();
      }
    } else {
      //otherwise it's the list view
      //loop over each installer
      for (var _i2 = 0; _i2 < installers.length; _i2++) {
        //fetch our data
        var data = installers[_i2]; //if this is the first item to render...

        if (_i2 === 0) {
          var _container$dataset$te, _container$dataset$te2;

          //fetch our title and description
          var title = (_container$dataset$te = container.dataset.text_title) !== null && _container$dataset$te !== void 0 ? _container$dataset$te : false;
          var description = (_container$dataset$te2 = container.dataset.text_description) !== null && _container$dataset$te2 !== void 0 ? _container$dataset$te2 : false; //add our header

          container.innerHTML = "<div class=\"md:col-span-2\">\n                        <h2 class=\"text-[22px] lg:text-[31px] ".concat(data['type'] === 'product-champions' ? '!my-0' : '!mt-0 !mb-5', "\">\n                            ").concat(title ? title : 'Your nearest installers', "\n                        </h2>\n                        ").concat(data['type'] === 'product-champions' ? "<p class=\"!mt-2 !mb-5 text-sm md:text-base\">\n                            ".concat(description ? description : "You can request as many quotes as you like. We'll send your details to the installers you select and they'll get in touch with you directly.", "\n                        </p>") : '', "\n                    </div>");
        } //append the item to the container


        container.innerHTML += "<div class=\"installers-list-item bg-white border border-[#C5C5C5] w-full flex flex-wrap xl:flex-nowrap px-3.5 xl:pl-6 xl:pr-5 py-5 xl:py-4 space-y-2 xl:space-y-0 xl:space-x-6 rounded-2.5xl lg:mb-3.5 justify-between 2xl:justify-normal items-start xl:items-center\" data-slug=\"".concat(data['data']['slug'], "\">") + render_item(data, view, default_search) + "</div>";
      } //check if we have any existing quotes


      check_existing_quotes();
    } //indicate we're no longer rendering


    installers_rendering = false;
  }

  disable_loader();
}

function render_item(item, view, default_search) {
  var _document$querySelect, _item$data$name;

  //attempt to find our quote ID from the URL
  var urlParams = new URLSearchParams(window.location.search);
  var quote_id = urlParams.get('quote'); //define a default (empty) logo

  var logo = ''; //define our path to the approved logo

  var approved = '/wp-content/themes/myenergi-multisite/graphics/installers/myenergi-approved.svg'; //if we have a logo

  if (item['data']['logo']) {
    //set the logo
    logo = item['data']['logo'];
  } //define this as false initially


  var form_page = false; //depending on the view we're currently using

  switch (view) {
    case 'map':
      //fetch the form page
      form_page = document.getElementById('installersMap').dataset.form_page;
      break;

    case 'list':
      //fetch the form page
      form_page = document.getElementById('installersList').dataset.form_page;
      break;
  } //fetch all inputs of the "product_type" checkboxes (if they exist)


  var filtered_products = (_document$querySelect = document.querySelectorAll('input[name="product_type[]"]:checked')) !== null && _document$querySelect !== void 0 ? _document$querySelect : []; //if we have some inputs

  if (filtered_products && filtered_products.length > 0) {
    //create an array to hold the values
    var values = []; //loop through each input

    filtered_products.forEach(function (input) {
      //add the value to the array
      values.push(input.value);
    }); //set the filtered products to the values

    filtered_products = values;
  } else {
    //redefine the filtered products as an empty array
    filtered_products = [];
  }

  return "\n        <div class=\"flex justify-between items-start lg:items-center ".concat(view === 'map' ? '' : (logo ? '' : 'hidden') + ' w-[70px] mr-5 lg:mr-0', "\">\n            ").concat(logo ? "<img src=\"".concat(logo, "\" class=\"installers-request-logo object-contain ").concat(view === 'map' ? 'max-h-[42px]' : 'w-[70px] max-h-[42px]', "\" data-id=\"").concat(item['data']['id'], "\" />") : '', "\n            ").concat(view === 'map' && item['type'] == 'product-champions' ? "<img class=\"".concat(logo ? "translate-x-2" : '', "\" src=\"").concat(approved, "\" />") : '', "\n        </div>\n        <p class=\"text-black font-bold leading-normal ").concat(view === 'map' ? (item['type'] == 'product-champions' ? '!mt-3' : '!mt-0') + ' block !mb-0 text-sm' : 'text-xs xl:text-sm !mt-0 !mb-6 xl:!mb-0 xl:font-normal xl:w-[150px]' + (logo ? ' w-[calc(100%-90px)] text-right xl:text-left' : ' w-full text-left'), "\">\n            ").concat((_item$data$name = item['data']['name']) !== null && _item$data$name !== void 0 ? _item$data$name : 'N/A', "\n        </p>\n        <p class=\"font-bold text-black  ").concat(view === 'map' ? '!mt-3 !mb-0 text-sm' : '!my-0 xl:flex-1 text-xs xl:text-sm !-mt-1 xl:!mt-0', "\">\n            <span class=\"installers-quote-confrmation font-normal\" data-id=\"").concat(item['data']['id'], "\"></span>\n            <span class=\"").concat(view === 'map' ? '' : '', "\">").concat(item['data']['city'] ? item['data']['city'].toLowerCase().replace(/(?<= )[^\s]|^./g, function (a) {
    return a.toUpperCase();
  }) : '-', "</span>\n            ").concat(!default_search ? "<small class=\"block font-normal ".concat(view === 'map' ? '!-mt-1 text-sm' : 'text-xs 2xl:text-sm', "\">\n                (").concat(parseFloat(item['distance']).toFixed(1), " ").concat(item['unit'], " ").concat(view === 'map' ? 'from your location' : '<span class="xl:hidden">away</span><span class="hidden xl:inline">from your location</span>', ")\n            </small>") : '', "\n        </p>\n        ").concat(view === 'list' && item['type'] == 'product-champions' ? "\n            <div class=\"installers-quote-id font-normal text-sm xl:w-[40px] 2xl:w-[75px] flex items-start xl:items-center justify-center !mt-0\" data-id=\"".concat(item['data']['id'], "\">\n                <img src=\"").concat(approved, "\" class=\"").concat(view === 'map' ? '' : 'w-[24px] xl:w-auto', "\" />\n            </div>") : '', "\n        ").concat(quote_id ? "<button type=\"button\" class=\"installers-request-quote btn w-full !px-2 self-end ".concat(view === 'map' ? 'mt-3' : 'xl:self-center xl:max-w-[205px]', "\" data-id=\"").concat(item['data']['id'], "\" data-view=\"").concat(view, "\">\n            Request Quote\n        </button>") : "<div class=\" ".concat(view === 'map' ? 'mt-3 space-y-2' : 'pt-3 w-full space-y-2 xs:flex xs:flex-wrap xs:space-x-2 xs:space-y-0 xs:self-center xl:pt-0 xl:space-y-2 xl:space-x-0 xl:flex-col xl:max-w-[200px] 2xl:flex-row 2xl:space-y-0 2xl:space-x-2 2xl:max-w-[375px] 2xl:min-w-[300px]', "\">\n            <p class=\"w-full font-bold text-black !mt-0 !mb-2 text-sm\">Request a quote:</p>\n            ").concat(view !== 'map' ? '<div class="w-full flex space-x-2 items-center !ml-0">' : '', "\n                ").concat(form_page && item['type'] == 'product-champions' && item['products']['zappi'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('zappi')) ? "<a href=\"" + form_page + "?product_type=zappi&installer=".concat(item['data']['id'], "\" class=\"btn !bg-black !border-black !text-white installers-loading-toggle !px-2 self-end w-full ").concat(view !== 'map' ? 'max-w-[100px] xl:max-w-[33%]' : '', "\" data-view=\"").concat(view, "\">\n                    zappi\n                </a>") : "", "\n                ").concat(form_page && item['type'] == 'product-champions' && item['products']['eddi'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('eddi')) ? "<a href=\"" + form_page + "?product_type=eddi&installer=".concat(item['data']['id'], "\" class=\"btn !bg-black !border-black !text-white installers-loading-toggle !px-2 self-end w-full ").concat(view !== 'map' ? 'max-w-[100px] xl:max-w-[33%]' : '', "\" data-view=\"").concat(view, "\">\n                    eddi\n                </a>") : "", "\n                ").concat(form_page && item['type'] == 'product-champions' && item['products']['libbi'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('libbi')) ? "<a href=\"" + form_page + "?product_type=libbi&installer=".concat(item['data']['id'], "\" class=\"btn !bg-black !border-black !text-white installers-loading-toggle !px-2 self-end w-full ").concat(view !== 'map' ? 'max-w-[100px] xl:max-w-[33%]' : '', "\" data-view=\"").concat(view, "\">\n                    libbi\n                </a>") : "", "\n                ").concat(!form_page && item['type'] != 'product-champions' && item['data']['email'] ? "<a href=\"mailto:".concat(item['data']['email'], "\" class=\"btn w-full !px-2 self-end\">\n                    Email\n                </a>") : "", "\n                ").concat(!form_page && item['type'] != 'product-champions' && item['data']['phone'] ? "<a href=\"tel:".concat(item['data']['phone'], "\" class=\"btn w-full !px-2 self-end\">\n                    Call\n                </a>") : "", "\n            ").concat(view !== 'map' ? '</div>' : '', "\n        </div>"), "\n    ");
}

function hide_markers() {
  //wrap in a try/catch to prevent errors
  try {
    //loop through the markers
    for (var i = 0; i < markers.length; i++) {
      //if the map bounds contain the marker position
      if (window.installer_map.getBounds().contains(markers[i].getPosition())) {
        //set the map to the marker
        markers[i].setMap(window.installer_map);
      } else {
        //if the map bounds don't contain the marker position
        //set the map to null
        markers[i].setMap(null);
      }
    } //if pin grouping is enabled


    if (window.installer_map_pin_grouping) {
      //regroup the markers
      group_markers();
    }
  } catch (e) {//ignore the error
  }
}

function group_markers() {
  // Remove any existing clusters before applying new ones
  if (window.installer_markerClusterer) {
    window.installer_markerClusterer.clearMarkers();
    window.installer_markerClusterer = null;
  }

  window.installer_markerClusterer = new MarkerClusterer({
    map: window.installer_map,
    markers: window.installer_markers,
    renderer: {
      render: function render(_ref) {
        var count = _ref.count,
            position = _ref.position;
        return new google.maps.Marker({
          position: position,
          icon: {
            url: installers_script_vars.theme_path + '/graphics/installers/pin-group.svg',
            scaledSize: new google.maps.Size(70, 70)
          },
          label: {
            text: String(count),
            color: "#fff",
            fontSize: "16px",
            fontWeight: "bold"
          },
          zIndex: 1000 + count
        });
      }
    }
  });
}

function init_quote_handler() {
  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('installers-loading-toggle')) return; //toggle our loader

    toggle_loader();
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('installers-request-quote')) return; //attempt to find our quote ID from the URL

    var urlParams = new URLSearchParams(window.location.search);
    var quote_id = urlParams.get('quote'); //attempt to fetch our installer ID

    var installer_id = event.target.dataset.id;

    if (installer_id) {
      //attempt to fetch the view we're rendering
      var view = event.target.dataset.view;
      var _endpoint = false;

      if (view) {
        switch (view) {
          case 'map':
            //fetch the map element
            view = document.getElementById('installersMap');
            break;

          case 'list':
            //fetch the list element
            view = document.getElementById('installersList');
            break;
        } //fetch the endpoint from the specified view


        _endpoint = view.dataset.quote_endpoint;
      } //if we have a quote ID


      if (quote_id) {
        //create a new xhr
        var xhttp = new XMLHttpRequest(); //when the request state changes

        xhttp.onreadystatechange = function () {
          //if our request is complete
          if (this.status === 200) {
            //default to no response
            var response = false; //try...

            try {
              //... to parse the response
              response = JSON.parse(xhttp.responseText); //fetch our confirmation page

              var confirmation = document.getElementById('quote-confirmation');
              var confirmation_date = confirmation.querySelector('#installer-quote-confirmation-date');
              var confirmation_id = confirmation.querySelector('#installer-quote-confirmation-quote-id');
              var confirmation_logo = confirmation.querySelector('#installer-quote-confirmation-logo');
              var confirmation_approved = confirmation.querySelector('#installer-quote-confirmation-approved'); //fetch our email/phone

              var installer_phone = confirmation.querySelector('#installer-quote-confirmation-phone');
              var installer_email = confirmation.querySelector('#installer-quote-confirmation-email'); //if we have a confirmation modal

              if (confirmation) {
                //add the active class, showing the confirmation
                confirmation.classList.add('active'); //pop the state without reloading the page

                history.pushState({}, '', window.location.pathname + '?quote=' + quote_id);
              } //if we have a response time


              if (response.time && confirmation_date) {
                //update the response time
                confirmation_date.innerHTML = response.time;
              } //if we have a response reference


              if (response.reference && confirmation_date) {
                //update the response time
                confirmation_id.innerHTML = 'Quote ID Number: ' + response.reference;
              } //if we have a response and it contains an phone number


              if (installer_phone && response.installer.phone) {
                //set the href
                installer_phone.href = 'tel:' + response.installer.phone; //find the last span child and add the phone number to it

                installer_phone.children[1].innerHTML = response.installer.phone; //show the phone number

                installer_phone.classList.remove('hidden');
              } else {
                //remove the phone number
                installer_phone.href = '';
                installer_phone.children[1].innerHTML = ''; //hide the phone number

                installer_phone.classList.add('hidden');
              } //if we have a response and it contains an email


              if (installer_email && response.installer.email) {
                //set the href
                installer_email.href = 'mailto:' + response.installer.email; //find the last span child and add the email to it

                installer_email.children[1].innerHTML = response.installer.email; //show the email

                installer_email.classList.remove('hidden');
              } else {
                //remove the email
                installer_email.href = '';
                installer_email.children[1].innerHTML = ''; //hide the email

                installer_email.classList.add('hidden');
              } //if we have a response and it contains a logo


              if (response.installer.logo && confirmation_logo) {
                //update the logo
                confirmation_logo.src = response.installer.logo;
              } else {
                //remove the logo
                confirmation_logo.src = '';
              } //check if we have any existing quotes


              check_existing_quotes(); //disable the loader

              disable_loader();
            } catch (error) {
              //if there's an error...
              //ignore it, we don't need to do anything
              disable_loader();
            }
          } else if (this.response === 400) {
            //check if a toast is already being displayed
            if (!document.querySelector('.toastify')) {
              //display a error message to the user
              Toastify({
                text: "There was an issue requesting your quote. Please try again.",
                duration: 5000,
                gravity: "bottom",
                position: "center",
                stopOnFocus: true,
                className: "!bg-red"
              }).showToast();
            }

            disable_loader();
          }
        }; //enable the loader


        toggle_loader(); //open the request

        xhttp.open("GET", _endpoint + '?quote=' + quote_id + '&installer=' + installer_id, true); //send the request

        xhttp.send();
      }
    } else {
      //display a error message to the user
      Toastify({
        text: "You've already requested a quote from this installer.",
        duration: 5000,
        gravity: "bottom",
        position: "center",
        stopOnFocus: true,
        className: "!bg-red"
      }).showToast();
    }
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('close-quote')) return; //fetch our confirmation page

    var confirmation = document.getElementById('quote-confirmation'); //if we have a confirmation modal

    if (confirmation) {
      //add the active class, showing the confirmation
      confirmation.classList.remove('active');
    }
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('open-installer-quote-prompt')) return; //fetch our prompt

    var prompt = document.getElementById('installer-quote-prompt'); //if we have a confirmation modal

    if (prompt) {
      //reveal the prompt
      prompt.classList.remove('hidden');
    }
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('close-installer-quote-prompt')) return; //fetch our prompt

    var prompt = document.getElementById('installer-quote-prompt'); //if we have a confirmation modal

    if (prompt) {
      //hide the prompt
      prompt.classList.add('hidden');
    }
  }); //adds a form submit handler for the manual search form

  document.addEventListener("submit", function (event) {
    if (!event.target.classList.contains('installer-manual-search')) return; //prevent the default form submission

    event.preventDefault(); //get installers

    get_installers(event.target);
  });

  window.onpopstate = function () {
    return setTimeout(function () {
      var confirmation = document.getElementById('quote-confirmation');

      if (confirmation && confirmation.classList.contains('active')) {
        confirmation.classList.remove('active');
        return;
      }
    }, 0);
  };
}

function check_existing_quotes() {
  var _document$getElementB;

  var cached = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var now = Date.now(); // Prevent this from running more than once every second

  if (now - lastCheckTime < 1000) {
    return;
  }

  lastCheckTime = now; //attempt to find our quote ID from the URL

  var urlParams = new URLSearchParams(window.location.search);
  var quote_id = urlParams.get('quote'); //if we don't have a quote ID

  if (!quote_id) {
    //disable the loader
    disable_loader(); //bail

    return;
  } //if we're using the cached version


  if (cached) {
    //fetch the cached quotes
    var quotes = localStorage.getItem('quotes'); //if we have quotes

    if (quotes) {
      //parse the quotes
      apply_existing_quotes(JSON.parse(quotes)); //bail

      return;
    }
  } //default our endpoint to false


  var endpoint = false; //fetch the view element

  var view = (_document$getElementB = document.getElementById('installersMap')) !== null && _document$getElementB !== void 0 ? _document$getElementB : document.getElementById('installersList'); //if we have a view

  if (view) {
    //fetch the endpoint from the specified view
    endpoint = view.dataset.existing_quotes_endpoint;
  } //if we don't have an endpoint at this stage


  if (!endpoint) {
    //disable the loader
    disable_loader(); //bail

    return false;
  } //create a new xhr


  var xhttp = new XMLHttpRequest(); //when the request state changes

  xhttp.onreadystatechange = function () {
    //if our request is complete
    if (this.status === 200) {
      //try...
      try {
        //parse the response
        var _quotes = JSON.parse(xhttp.responseText); //store this response in the cache


        localStorage.setItem('quotes', JSON.stringify(_quotes)); //apply the existing quotes

        apply_existing_quotes(_quotes); //disable the loader

        disable_loader();
      } catch (error) {
        //if there's an error...
        //ignore it, we don't need to do anything
        //disable the loader
        disable_loader();
      }
    }
  }; //open the request


  xhttp.open("GET", endpoint + '?quote=' + quote_id, true); //send the request

  xhttp.send();
}

function apply_existing_quotes(quotes) {
  //if we have some quotes already
  if (quotes && quotes.length > 0) {
    //loop over the quotes
    for (var i = 0; i < quotes.length; i++) {
      //store the quote
      var quote = quotes[i]; //check to see if there's a logo available

      var logo = document.querySelector('.installers-request-logo[data-id="' + quote['installer']['id'] + '"]'); //check to see if there's a button to disable

      var button = document.querySelector('.installers-request-quote[data-id="' + quote['installer']['id'] + '"]'); //check to see if we have any confirmation elements

      var confirmation = document.querySelector('.installers-quote-confrmation[data-id="' + quote['installer']['id'] + '"]'); //check to see if we have any quote confirmation elements

      var confirmation_quote = document.querySelector('.installers-quote-id[data-id="' + quote['installer']['id'] + '"]'); //default this to false initially, if we can find it we'll update it

      var list_item = false; //try to find the list item

      try {
        //fetch the list item
        list_item = button.closest('.installers-list-item');
      } catch (e) {//otherwise it can't be found
      } //if we have a button


      if (button) {
        //change the button text
        button.innerHTML = 'Quote Request Sent'; //remove the installer id

        button.removeAttribute('data-id'); //make it visually different

        button.classList.add('!bg-[#DBDBDB]');
        button.classList.add('!border-[#DBDBDB]');
        button.classList.add('!text-[#919191]');
        button.classList.add('pointer-events-none');
        button.classList.add('select-none');
      } //if we have a confirmation element


      if (confirmation) {
        //remove the installer id
        confirmation.removeAttribute('data-id'); //add the confirmation text

        confirmation.innerHTML = (!list_item ? "<div class=\"opacity-75\">" : '') + "Successfully requested on: <strong class=\"block\">" + quote.time + "</strong>" + (!list_item ? "</div>" : ''); //if we don't have a confirmation quote

        if (!confirmation_quote) {
          //add our quote ID here instead
          confirmation.innerHTML += "<div class=\"mt-2" + (!list_item ? " opacity-75" : '') + "\">Quote ID Number: <strong class=\"block\">" + quote.reference + "</strong></div>";
        } //if this is a list item


        if (list_item) {
          //add responsive classes
          confirmation.parentNode.classList.add('w-full');
          confirmation.parentNode.classList.add('xl:w-auto');
          confirmation.parentNode.classList.add('!mt-2');
          confirmation.parentNode.classList.add('xl:!mt-0');
        } //indicate it's been confirmed


        confirmation.classList.add('active');
      } //if we have a confirmation quote element


      if (confirmation_quote) {
        //remove the installer id
        confirmation_quote.removeAttribute('data-id'); //add the quote confirmation text

        confirmation_quote.innerHTML = "<div>Quote ID Number: <strong class=\"block\">" + quote.reference + "</strong></div>"; //if this is a list item

        if (list_item) {
          //make responsiveness changes to the parent item
          confirmation_quote.classList.remove('flex-1');
          confirmation_quote.classList.add('xl:flex-1');
          confirmation_quote.classList.remove('!mt-0');
          confirmation_quote.classList.add('!mt-2');
          confirmation_quote.classList.add('xl:!mt-0');
        }
      } //if we have a list item that's not already been disabled


      if (list_item && !list_item.classList.contains('opacity-50')) {
        //visually indicate it's inactive
        list_item.classList.add('opacity-50');
        list_item.classList.add('border-opacity-50');
      } //if we have some map markers


      if (markers && markers.length > 0) {
        //loop over our map markers
        for (var ii = 0; ii < markers.length; ii++) {
          //if the installer ID matches the quote installer ID
          if (parseInt(markers[ii]['installerId']) === parseInt(quote['installer']['id'])) {
            //change the default icon
            markers[ii].setIcon({
              url: installers_script_vars.theme_path + '/graphics/installers/pin-quoted.svg',
              scaledSize: new google.maps.Size(28, 43)
            }); //force the map to update

            markers[ii].setMap(window.installer_map);
          }
        }
      }
    }
  }
}